"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var widgets_datagrid_1 = require("@tableau/widgets-datagrid");
var React = require("react");
var Localize_1 = require("../../../../gen-src/Localize");
var RootReducer_1 = require("../../../app/RootReducer");
var ModelResultStyles_1 = require("../../../styles/ModelResultStyles");
var NumberUtils_1 = require("../../../util/NumberUtils");
var Utils_1 = require("../../../util/Utils");
var Index_1 = require("../../base/Index");
// The columns of the grid
var ColumnKeys;
(function (ColumnKeys) {
    ColumnKeys["MetricName"] = "metricName";
    ColumnKeys["MetricDescription"] = "metricDescription";
    ColumnKeys["InfoIcon"] = "infoIcon";
    ColumnKeys["TrainingSet"] = "trainingSet";
    ColumnKeys["ValidationSet"] = "validationSet";
    ColumnKeys["Fold1"] = "fold1";
    ColumnKeys["Fold2"] = "fold2";
    ColumnKeys["Fold3"] = "fold3";
    ColumnKeys["Fold4"] = "fold4";
})(ColumnKeys || (ColumnKeys = {}));
// Cell formatter for the info icon column
var InfoIconFormatter = function (props) {
    return (React.createElement("div", null,
        React.createElement(Index_1.InfoPopover, { title: props.row.data[ColumnKeys.MetricName], description: props.row.data[ColumnKeys.MetricDescription] })));
};
var isRegression = function (type) {
    if (!type)
        return false;
    return (0, Utils_1.isRegressionModel)(type);
};
var getFieldFractionDigits = function (num) {
    return num > 1 ? 2 : 3;
};
var REGRESSION_TABLE_HEIGHT = 460;
var BINARY_TABLE_HEIGHT = 240;
var ModelResultCrossValidation = function () {
    var _a = (0, RootReducer_1.useAppSelector)(function (state) { return state.modelResult; }), type = _a.type, modelMetrics = _a.modelMetrics;
    var headerComponent = function (props) { return (React.createElement("div", { className: ModelResultStyles_1.DataGridHeader },
        React.createElement("div", { className: ModelResultStyles_1.DataGridHeaderText }, props.col.headerText))); };
    // Build Columns
    var cols = [
        {
            name: ColumnKeys.MetricName,
            dataKey: ColumnKeys.MetricName,
            headerText: Localize_1.Messages.modelResultsCrossValidationMetricName(),
            headerComponent: headerComponent,
            growToFit: true,
        },
        {
            name: ColumnKeys.InfoIcon,
            dataKey: ColumnKeys.InfoIcon,
            headerText: '',
            headerComponent: headerComponent,
            cellFormatter: React.createFactory(InfoIconFormatter),
            growToFit: true,
        },
        {
            name: ColumnKeys.TrainingSet,
            dataKey: ColumnKeys.TrainingSet,
            headerText: Localize_1.Messages.modelResultsCrossValidationTrainingSet(),
            headerComponent: headerComponent,
            growToFit: true,
        },
        {
            name: ColumnKeys.ValidationSet,
            dataKey: ColumnKeys.ValidationSet,
            headerText: Localize_1.Messages.modelResultsCrossValidationValidationSet(),
            headerComponent: headerComponent,
            growToFit: true,
        },
        {
            name: ColumnKeys.Fold1,
            dataKey: ColumnKeys.Fold1,
            headerText: Localize_1.Messages.modelResultsCrossValidationFold1(),
            headerComponent: headerComponent,
            growToFit: true,
        },
        {
            name: ColumnKeys.Fold2,
            dataKey: ColumnKeys.Fold2,
            headerText: Localize_1.Messages.modelResultsCrossValidationFold2(),
            headerComponent: headerComponent,
            growToFit: true,
        },
        {
            name: ColumnKeys.Fold3,
            dataKey: ColumnKeys.Fold3,
            headerText: Localize_1.Messages.modelResultsCrossValidationFold3(),
            headerComponent: headerComponent,
            growToFit: true,
        },
        {
            name: ColumnKeys.Fold4,
            dataKey: ColumnKeys.Fold4,
            headerText: Localize_1.Messages.modelResultsCrossValidationFold4(),
            headerComponent: headerComponent,
            growToFit: true,
        },
    ];
    var _b = React.useState({
        cols: cols,
        rowStore: new widgets_datagrid_1.ArrayRowStore([]),
        showHeaders: true,
        showHorizontalGridLines: true,
        showRowBanding: false,
    }), tableProps = _b[0], setTableProps = _b[1];
    var _c = React.useState(REGRESSION_TABLE_HEIGHT), tableHeight = _c[0], setTableHeight = _c[1];
    React.useEffect(function () {
        var buildRegressionTableRows = function () {
            if (!modelMetrics || !type) {
                return [];
            }
            var rows = [];
            var training = modelMetrics.training;
            var validation = modelMetrics.validation;
            var fold1 = modelMetrics.crossValidation[0];
            var fold2 = modelMetrics.crossValidation[1];
            var fold3 = modelMetrics.crossValidation[2];
            var fold4 = modelMetrics.crossValidation[3];
            var MetricDisplayNames = {
                nobs: Localize_1.Messages.modelResultsCrossValidationNumRows(),
                r2: Localize_1.Messages.modelResultsCrossValidationR2(),
                mse: Localize_1.Messages.modelResultsCrossValidationMSE(),
                rmse: Localize_1.Messages.modelResultsCrossValidationRMSE(),
                mae: Localize_1.Messages.modelResultsCrossValidationMAE(),
                rmsle: Localize_1.Messages.modelResultsCrossValidationRMSLE(),
                residualDeviance: Localize_1.Messages.modelResultsCrossValidationResidualDeviance(),
                meanResidualDeviance: Localize_1.Messages.modelResultsCrossValidationMeanResidualDeviance(),
                nullDeviance: Localize_1.Messages.modelResultsCrossValidationNullDeviance(),
                nullDegreesOfFreedom: Localize_1.Messages.modelResultsCrossValidationNullDegreesOfFreedom(),
                residualDegreesOfFreedom: Localize_1.Messages.modelResultsCrossValidationResidualDegreesOfFreedom(),
            };
            var MetricDescriptions = {
                nobs: Localize_1.Messages.modelResultsCrossValidationInfoNumberOfRows(),
                r2: Localize_1.Messages.modelResultsCrossValidationInfoR2(),
                mse: Localize_1.Messages.modelResultsCrossValidationInfoMSE(),
                rmse: Localize_1.Messages.modelResultsCrossValidationInfoRMSE(),
                mae: Localize_1.Messages.modelResultsCrossValidationInfoMAE(),
                rmsle: Localize_1.Messages.modelResultsCrossValidationInfoRMSLE(),
                residualDeviance: Localize_1.Messages.modelResultsCrossValidationInfoResidualDeviance(),
                meanResidualDeviance: Localize_1.Messages.modelResultsCrossValidationInfoMeanResidualDeviance(),
                nullDeviance: Localize_1.Messages.modelResultsCrossValidationInfoNullDeviance(),
                nullDegreesOfFreedom: Localize_1.Messages.modelResultsCrossValidationInfoNullDegreesofFreedom(),
                residualDegreesOfFreedom: Localize_1.Messages.modelResultsCrossValidationInfoResidualDegreesOfFreedom(),
            };
            Object.entries(MetricDisplayNames).forEach(function (_a) {
                var _b;
                var mName = _a[0], mValue = _a[1];
                var regressionKey = mName;
                var trainingSetValue = training[regressionKey];
                var validationSetValue = validation[regressionKey];
                var fold1Value = fold1[regressionKey];
                var fold2Value = fold2[regressionKey];
                var fold3Value = fold3[regressionKey];
                var fold4Value = fold4[regressionKey];
                rows.push({
                    key: mName,
                    data: (_b = {},
                        _b[ColumnKeys.MetricName] = mValue,
                        _b[ColumnKeys.MetricDescription] = MetricDescriptions[mName],
                        _b[ColumnKeys.TrainingSet] = (0, NumberUtils_1.formatNumericField)({
                            value: trainingSetValue,
                            fractionDigits: getFieldFractionDigits(trainingSetValue),
                        }),
                        _b[ColumnKeys.ValidationSet] = (0, NumberUtils_1.formatNumericField)({
                            value: validationSetValue,
                            fractionDigits: getFieldFractionDigits(validationSetValue),
                        }),
                        _b[ColumnKeys.Fold1] = (0, NumberUtils_1.formatNumericField)({ value: fold1Value, fractionDigits: getFieldFractionDigits(fold1Value) }),
                        _b[ColumnKeys.Fold2] = (0, NumberUtils_1.formatNumericField)({ value: fold2Value, fractionDigits: getFieldFractionDigits(fold2Value) }),
                        _b[ColumnKeys.Fold3] = (0, NumberUtils_1.formatNumericField)({ value: fold3Value, fractionDigits: getFieldFractionDigits(fold3Value) }),
                        _b[ColumnKeys.Fold4] = (0, NumberUtils_1.formatNumericField)({ value: fold4Value, fractionDigits: getFieldFractionDigits(fold4Value) }),
                        _b),
                });
            });
            return rows;
        };
        var buildBinomialTableRow = function () {
            if (!modelMetrics || !type) {
                return [];
            }
            var rows = [];
            var training = modelMetrics.training;
            var validation = modelMetrics.validation;
            var fold1 = modelMetrics.crossValidation[0];
            var fold2 = modelMetrics.crossValidation[1];
            var fold3 = modelMetrics.crossValidation[2];
            var fold4 = modelMetrics.crossValidation[3];
            var MetricDisplayNames = {
                nobs: Localize_1.Messages.modelResultsCrossValidationNumRows(),
                auc: Localize_1.Messages.modelResultsCrossValidationR2(),
                gini: Localize_1.Messages.modelResultsCrossValidationGINI(),
                logloss: Localize_1.Messages.modelResultsCrossValidationLogLoss(),
                meanPerClassError: Localize_1.Messages.modelResultsCrossValidationMeanPerClassError(),
            };
            var MetricDescriptions = {
                nobs: Localize_1.Messages.modelResultsCrossValidationInfoNumberOfRows(),
                auc: Localize_1.Messages.modelResultsCrossValidationInfoAUC(),
                gini: Localize_1.Messages.modelResultsCrossValidationInfoGINI(),
                logloss: Localize_1.Messages.modelResultsCrossValidationInfoLogLoss(),
                meanPerClassError: Localize_1.Messages.modelResultsCrossValidationInfoMeanPerClassError(),
            };
            Object.entries(MetricDisplayNames).forEach(function (_a) {
                var _b;
                var mName = _a[0], mValue = _a[1];
                var regressionKey = mName;
                var trainingSetValue = training[regressionKey];
                var validationSetValue = validation[regressionKey];
                var fold1Value = fold1[regressionKey];
                var fold2Value = fold2[regressionKey];
                var fold3Value = fold3[regressionKey];
                var fold4Value = fold4[regressionKey];
                rows.push({
                    key: mName,
                    data: (_b = {},
                        _b[ColumnKeys.MetricName] = mValue,
                        _b[ColumnKeys.MetricDescription] = MetricDescriptions[mName],
                        _b[ColumnKeys.TrainingSet] = (0, NumberUtils_1.formatNumericField)({
                            value: trainingSetValue,
                            fractionDigits: getFieldFractionDigits(trainingSetValue),
                        }),
                        _b[ColumnKeys.ValidationSet] = (0, NumberUtils_1.formatNumericField)({
                            value: validationSetValue,
                            fractionDigits: getFieldFractionDigits(validationSetValue),
                        }),
                        _b[ColumnKeys.Fold1] = (0, NumberUtils_1.formatNumericField)({ value: fold1Value, fractionDigits: getFieldFractionDigits(fold1Value) }),
                        _b[ColumnKeys.Fold2] = (0, NumberUtils_1.formatNumericField)({ value: fold2Value, fractionDigits: getFieldFractionDigits(fold2Value) }),
                        _b[ColumnKeys.Fold3] = (0, NumberUtils_1.formatNumericField)({ value: fold3Value, fractionDigits: getFieldFractionDigits(fold3Value) }),
                        _b[ColumnKeys.Fold4] = (0, NumberUtils_1.formatNumericField)({ value: fold4Value, fractionDigits: getFieldFractionDigits(fold4Value) }),
                        _b),
                });
            });
            return rows;
        };
        var rows = [];
        if (isRegression(type)) {
            rows = buildRegressionTableRows();
            setTableHeight(REGRESSION_TABLE_HEIGHT);
        }
        else {
            rows = buildBinomialTableRow();
            setTableHeight(BINARY_TABLE_HEIGHT);
        }
        setTableProps({
            cols: cols,
            rowStore: new widgets_datagrid_1.ArrayRowStore(rows),
            showHeaders: true,
            showHorizontalGridLines: true,
            showRowBanding: false,
        });
    }, [modelMetrics, type]);
    return (React.createElement("div", { className: ModelResultStyles_1.DataGridContainer, style: { height: tableHeight } },
        React.createElement(widgets_datagrid_1.DataGrid, __assign({}, tableProps))));
};
exports.default = ModelResultCrossValidation;
//# sourceMappingURL=ModelResultCrossValidation.js.map